/**
 * The small line over a tile under `?stats=1` (stats.ts): what its picture really is, or what you send.
 * Draw it only when STATS_ON, so a plain page mounts nothing and reads nothing.
 */
import { type ReactNode, useEffect, useState } from "react";
import { statsOf, watchStats } from "./stats";

export function TileStats({ track, mine }: { track: MediaStreamTrack | null; mine: boolean }): ReactNode {
  const id = track?.id ?? "";
  const [lines, setLines] = useState<string[]>([]);
  useEffect(() => {
    if (!id) {
      setLines([]);
      return;
    }
    const read = () => setLines(statsOf(id, mine));
    read();
    return watchStats(read);
  }, [id, mine]);
  if (lines.length === 0) return null;
  return (
    <span
      className="tile-stats"
      aria-hidden="true"
      style={{
        position: "absolute",
        left: 4,
        top: 4,
        zIndex: 6,
        padding: "2px 5px",
        borderRadius: 4,
        background: "rgba(0,0,0,.7)",
        color: "#9ff0b8",
        font: "10px/1.3 ui-monospace, Menlo, Consolas, monospace",
        whiteSpace: "pre-wrap",
        maxWidth: "calc(100% - 8px)",
        pointerEvents: "none",
        textAlign: "left",
      }}
    >
      {mine ? `sent\n${lines.join("\n")}` : lines.join("\n")}
    </span>
  );
}
